import useWebview from '@/hooks/V3/useWebview';
import { useAppSelector } from '@/redux/store';
import { isMobileState } from '@/store/atom';
import { useRecoilValue } from 'recoil';
import { deviceUuidState } from '@/store/atom';
import { Button } from '@/components/V3/Button';
import NewsTutorial from '@/assets/images/V3/NewsTutorial.svg?react';
import TutorialChart from './TutorialChart';
import { useSearchParams } from 'react-router-dom';
import { buildUrlWithParams } from '@/utils/buildUrlWithParams';
import { useParams } from 'react-router-dom';
import { useSafeAreaSpacing } from '@/hooks/useSafeAreaSpacing';

const NewsBriefingTutorial = () => {
  const { UserNo, CplatToken } = useAppSelector((state) => state.user);
  const { postMessage } = useWebview();
  const isMobile = useRecoilValue(isMobileState);
  const deviceUuid = useRecoilValue(deviceUuidState);
  const { getBottomSpacing } = useSafeAreaSpacing();
  const [searchParams] = useSearchParams();
  const newsEvaluation = searchParams.get('newsEvaluation');
  const footerPaddingBottom = getBottomSpacing();
  const contentPaddingBottom = 84;

  const { group = 'apage' } = useParams();

  const handleSkipTutorial = () => {
    if (!UserNo) return;
    // 앱에 skipTutorial 저장
    postMessage({
      action: 'saveAsyncStorage',
      data: {
        [`news_skip_tutorial_${UserNo}`]: 'true',
      },
    });

    const url = buildUrlWithParams({
      basePath: `/news-briefing/${group}/`,
      defaultParams: {
        cplatToken: CplatToken,
        isMobile,
        deviceUuid,
        skipTutorial: true,
        newsEvaluation: newsEvaluation ?? 'null',
      },
    });

    window.location.replace(url);
  };

  return (
    <section
      className={`flex w-full flex-col items-center justify-center bg-gr-50  pt-[26px]  ${
        isMobile ? 'h-[100dvh] w-full flex-1  ' : 'w-full flex-1 '
      }`}
    >
      <div
        className="w-full flex-1 overflow-scroll px-[20px]"
        style={{ paddingBottom: contentPaddingBottom }}
      >
        <div className="flex flex-col gap-[37px]">
          <TutorialHeader />
          <NewsTutorial className="ml-[20px]" />
        </div>
        <div className="flex flex-col gap-[40px]">
          <TutorialSecondHeader />
          <TutorialChart />
        </div>
      </div>
      <div
        className="fixed bottom-0 left-0 flex w-full bg-gr-50 px-[20px] pt-[12px]"
        style={{ paddingBottom: footerPaddingBottom }}
      >
        <Button variant="SolidHigh" onClick={handleSkipTutorial}>
          이커머스 소식 보러가기
        </Button>
      </div>
    </section>
  );
};

export default NewsBriefingTutorial;

const TutorialHeader = () => {
  return (
    <article className="flex flex-col gap-[16px] text-gr-800 ">
      <div className="flex flex-col Title2S24">
        <h1>셀러를 위한 이커머스 소식</h1>
        <h1>꼭 필요한 정보만 정리했어요</h1>
      </div>
      <ul className="flex list-disc flex-col gap-[4px] pl-[28px] Body2M16">
        <li>매일 오전 6시 새로운 뉴스가 도착해요</li>
        <li>뉴스는 24시간 동안 제공돼요</li>
      </ul>
    </article>
  );
};

const TutorialSecondHeader = () => {
  return (
    <article className="mt-[63px] flex flex-col gap-[16px] text-gr-800 ">
      <div className="flex flex-col Title2S24">
        <h1>자주 언급된 키워드로</h1>
        <h1>트렌드를 빠르게 파악하세요</h1>
      </div>
      <div className="flex flex-col gap-[4px] Body2M16">
        <h4>뉴스에 많이 언급된 키워드를 모아</h4>
        <h4>지금 주목받는 소비 트렌드를 한 눈에 보여드려요</h4>
      </div>
    </article>
  );
};
